import React, { useState, useEffect, useContext } from "react";
import { Box } from "@mui/material";
import { WidgetContext } from "../../store/widgetContext";
import { getVoiceWidgetDomain } from "../../utils/common";
import { getOrigin, getWwsAssistantId } from "../../utils/widgetStorage";
import { useSession } from "../../session/useSession";


export function createUrlWithParams(baseUrl, params) {
	const url = new URL(baseUrl);
	Object.entries(params).forEach(([key, value]) => {
		if (value !== undefined && value !== null) {
			url.searchParams.append(key, value);
		}
	});
	return url.toString();
}

export default function Voice({ conversationId, handleNavigate, ...props }) {
	const { botId, tenantId, projectUUID, uuid } = props;
	const { assistant, hostName, pathName } = useContext(WidgetContext);
	const { sessionId } = useSession();
	const [iframeUrl, setIframeUrl] = useState(null);

	useEffect(() => {
		setIframeUrl(null);

		// Delay iframe loading until header animation completes (300ms + small buffer)
		const animationDelay = setTimeout(() => {
			const assistantId = assistant?._id || getWwsAssistantId();
			const localUUID = `${uuid}_${botId}`;
			const urlData = getOrigin();
			const origin = urlData ? JSON.stringify(urlData) : (hostName && pathName ? JSON.stringify({ hostname: hostName, pathname: pathName }) : null);

			console.log("[Voice] Building iframe params:", {
				assistantId,
				tenantId,
				botId,
				localUUID,
				hostName,
				pathName,
				origin,
				sessionId,
				conversationId,
			});

			const requiredParams = {
				assistantId,
				tenantId,
				botId,
				uuid: localUUID,
				originHost: hostName,
				originPath: pathName,
				conversationId: conversationId,
			};

			// Only include origin if we don't have originHost/originPath
			if (origin && !hostName && !pathName) {
				requiredParams.origin = origin;
			}

			const requiredParamsForCheck = { ...requiredParams };
			delete requiredParamsForCheck.conversationId;

			const allParamsAvailable = Object.values(requiredParamsForCheck).every(Boolean);
			console.log("[Voice] Params check:", { requiredParamsForCheck, allParamsAvailable });

			if (allParamsAvailable) {
				if (sessionId) {
					requiredParams.sessionId = sessionId;
				}
				const url = createUrlWithParams(getVoiceWidgetDomain(), requiredParams);
				console.log("[Voice] Iframe URL created:", url);
				setIframeUrl(url);
			} else {
				console.warn("[Voice] Missing params for iframe:", requiredParamsForCheck);
			}
		}, 350);

		return () => clearTimeout(animationDelay);
	}, [assistant?._id, tenantId, botId, hostName, pathName, conversationId, projectUUID, sessionId]);

	return (
		<Box
			sx={{
				width: "100%",
				height: "100%",
				display: "flex",
				flexDirection: "column",
				background: "white",
				borderRadius: "16px",
				overflow: "hidden",
			}}
		>
			{iframeUrl && (
				<iframe
					src={iframeUrl}
					allow="microphone *"
					style={{
						border: "none",
						width: "100%",
						height: "100%"
					}}
				/>
			)}
		</Box>
	);
}
